import React from "react";
import { Grid, Skeleton, Table, TableCell, TableRow } from "@mui/material";

const SkeletonTableListUsers: React.FC = () => {
  const rows = 11;
  const cols = 7;

  return (
    <div style={{ padding: "20px" }}>
      <Grid container sx={{ p: 2 }}>
        <Grid item xs={2}>
          <Skeleton variant="rectangular" width={160} height={40} />
        </Grid>
        <Grid
          item
          xs={2}
          sx={{ display: "flex", justifyContent: "start", ml: "-10px" }}
        >
          <Skeleton variant="rectangular" width={160} height={40} />
        </Grid>
        <Grid
          item
          xs={8}
          sx={{ display: "flex", justifyContent: "end", ml: "-20px" }}
        >
          <Skeleton variant="rectangular" width={100} height={40} />
        </Grid>
      </Grid>
      <Table>
        <tbody>
          {Array.from({ length: rows }, (_, row) => (
            <TableRow key={row}>
              {Array.from({ length: cols }, (_, col) => (
                <TableCell key={col} sx={{ height: 40 }}>
                  <Skeleton variant="rectangular" width={141} height={40} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SkeletonTableListUsers;
